import { extractMentionsFromString } from '@gem/utils';

import { IUserMention } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';

export function getMentionsDataFromText(text: string): IUserMention[] {
  const textMentions = extractMentionsFromString(text);
  const userMentions = [];

  for (const mention of textMentions) {
    const nickname = mention.replace('@', '');
    const user = Entities.usersStore.getUserByNickName(nickname);

    if (user) {
      userMentions.push({ userId: user.id, nickname });
    }
  }

  return userMentions;
}
